import * as i0 from '@angular/core';
import { Component, HostBinding, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class SeFeInlineListComponent {
    constructor() {
        this.role = 'list';
    }
}
SeFeInlineListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeInlineListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeInlineListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeInlineListComponent, selector: "se-fe-inline-list", host: { properties: { "attr.role": "this.role" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [":host{align-items:center;display:flex;flex-wrap:wrap;justify-content:flex-start;line-height:1.2em;margin-right:-1.5em;overflow:hidden}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeInlineListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-inline-list',
                    template: '<ng-content></ng-content>',
                    styleUrls: ['./se-fe-inline-list.component.scss']
                }]
        }], propDecorators: { role: [{
                type: HostBinding,
                args: ['attr.role']
            }] } });

class SeFeInlineListItemComponent {
    constructor() {
        this.role = 'listitem';
    }
}
SeFeInlineListItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeInlineListItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeInlineListItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeInlineListItemComponent, selector: "se-fe-inline-list-item", host: { properties: { "attr.role": "this.role" } }, ngImport: i0, template: '<span class="se-fe-list-bullet" aria-hidden="true">•</span><ng-content></ng-content>', isInline: true, styles: [":host{box-sizing:border-box;flex:0 0 auto;margin-left:-1.5em;margin-right:1.5em;max-width:100%;padding:.25em 0 .25em 1.5em}.se-fe-list-bullet{display:inline-block;margin-left:-1.5em;text-align:center;vertical-align:middle;width:1.5em}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeInlineListItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-inline-list-item',
                    template: '<span class="se-fe-list-bullet" aria-hidden="true">•</span><ng-content></ng-content>',
                    styleUrls: ['./se-fe-inline-list-item.component.scss']
                }]
        }], propDecorators: { role: [{
                type: HostBinding,
                args: ['attr.role']
            }] } });

class SeFeInlineListModule {
}
SeFeInlineListModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeInlineListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeInlineListModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeInlineListModule, declarations: [SeFeInlineListComponent, SeFeInlineListItemComponent], imports: [CommonModule], exports: [SeFeInlineListComponent, SeFeInlineListItemComponent] });
SeFeInlineListModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeInlineListModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeInlineListModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SeFeInlineListComponent, SeFeInlineListItemComponent],
                    exports: [SeFeInlineListComponent, SeFeInlineListItemComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SeFeInlineListComponent, SeFeInlineListItemComponent, SeFeInlineListModule };
